/**
 * 平滑滚动顶部
 * @author wm
 * @DateTime 2018-09-29
 */
import qs from 'qs';
import { isInAPP } from './types';
import raf from 'raf';
import { zhidiao } from './jsBridge';
const scrollToTop = () => {
    const c = document.documentElement.scrollTop || document.body.scrollTop;
    if (c > 0) {
        // window.requestAnimationFrame(scrollToTop);
        raf(scrollToTop);
        window.scrollTo(0, c - c / 8);
    }
};

/**
 * 元素是否可见
 * @param {any} el
 * @param {boolean} partiallyVisible 是否完全可见
 */
const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    return partiallyVisible
        ? ((top > 0 && top < window.innerHeight) ||
              (bottom > 0 && bottom < window.innerHeight)) &&
              ((left > 0 && left < window.innerWidth) ||
                  (right > 0 && right < window.innerWidth))
        : top >= 0 &&
              left >= 0 &&
              bottom <= window.innerHeight &&
              right <= window.innerWidth;
};
/**
 * 滚动
 * @Author   wangmeng
 * @DateTime 2019-02-22
 * @param    {object}   element dom
 * @param    {number}   speed   speed
 */
const animateScroll = (element, speed = 30) => {
    let rect = element.getBoundingClientRect();
    //获取元素相对窗口的top值，此处应加上窗口本身的偏移
    let top = window.pageYOffset + rect.top;
    let currentTop = 0;
    let requestId;
    //采用requestAnimationFrame，平滑动画
    function step(timestamp) {
        currentTop += speed;
        if (currentTop <= top) {
            window.scrollTo(0, currentTop);
            requestId = window.requestAnimationFrame(step);
        } else {
            window.cancelAnimationFrame(requestId);
        }
    }
    window.requestAnimationFrame(step);
};

const smoothScroll = (element, block = 'start') =>
    element.scrollIntoView({
        behavior: 'smooth',
        block,
        inline: 'nearest',
    });

/**
 * 验证邮箱
 * @author   wm
 * @DateTime 2018-09-05
 * @param {string} str 验证的邮箱
 * @returns {boolean} 是否是邮箱
 */
const validateEmail = (str) =>
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        str
    );

/**
 * 验证数字
 * @author   wm
 * @DateTime 2018-09-05
 * @param {string} n 验证的数字
 * @returns {boolean} 是否是数据
 */
const validateNumber = (n) =>
    !isNaN(parseFloat(n)) && isFinite(n) && Number(n) == n;

/**
 * 验证数字或大小写字母
 * @param {*} n 被验证字段
 * @param {*} time 长度
 */
const validateNumberAndLetter = (n, time) => {
    // let reg = time ? eval("/^[A-Za-z0-9]{" + time + "}$/") : /^[A-Za-z0-9]+$/;
    let reg = time ? `/^[A-Za-z0-9]${time}$/"` : /^[A-Za-z0-9]+$/;
    return reg.test(n);
};
/**
 * 验证电话
 * @author   wm
 * @DateTime 2018-09-05
 * @param {string} n 验证的电话
 * @returns {boolean} 是否是电话号码
 */

const validataPhone = (n) => /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(n);

/**
 * 验证固定电话
 * @author   wm
 * @DateTime 2018-09-05
 * @param {string} n 验证的固定电话
 * @returns {boolean} 是否是固定电话
 */

const validataFixedLineTelephone = (n) => /\d{2,5}-\d{7,8}/.test(n);

/**
 * 判断平台 pc
 * @author wm
 * @returns {string} 平台类型
 */

const validataOS = () => {
    if (navigator.userAgent.indexOf('Window') > 0) {
        return 'Windows';
    } else if (navigator.userAgent.indexOf('Mac OS X') > 0) {
        return 'Mac';
    } else if (navigator.userAgent.indexOf('Linux') > 0) {
        return 'Linux';
    } else {
        return 'NUll';
    }
};
/**
 * 获取滚动条位置
 * @return {Number} 滚动条位置
 */
const getScrollTop = (_) => {
    let scrollTop = 0;
    if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
    } else if (document.body) {
        scrollTop = document.body.scrollTop;
    }
    return scrollTop;
};

/**
 * 获取可视范围高度
 * @return {Number} 可视范围高度
 */
const getClientHeight = (_) => {
    let clientHeight = 0;
    if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(
            document.body.clientHeight,
            document.documentElement.clientHeight
        );
    } else {
        clientHeight = Math.max(
            document.body.clientHeight,
            document.documentElement.clientHeight
        );
    }
    return clientHeight;
};
/**
 * 获取文档完整的高度
 * @return {Number} 文档高度
 */
const getScrollHeight = (_) => {
    return Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
    );
};
/**
 *  倒计时 距离某日
 * @params {*} 不传，则默认到当天凌晨12点，  array: [2019, 4, 14, 0, 0, 0, 0] 5月 14号
 * @params {String} 时间分割符号
 * @return {String} "**:**:**"
 */
const timeToNextDay = (date, split = ':') => {
    // 现在距离 1970-1-1 毫秒数
    let d = new Date();
    let now = d.getTime();
    let today = null;
    let nextDay = null;
    // 今天凌晨或某日凌晨距离 1970-1-1 毫秒数
    // let today = date
    // ? new Date(date).getTime() - 8 * 60 * 60 * 1000
    // ? new Date(date).getTime()
    // : new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    if (!date) {
        today = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
        nextDay = today + 24 * 60 * 60 * 1000;
    } else if (Array.isArray(date)) {
        today = new Date(...date).getTime();
        nextDay = today;
    } else if (typeof date === 'string') {
        new Date(date).getTime();
        nextDay = today;
    }
    // let nextDay = today + 24 * 60 * 60 * 1000;
    let dis = (nextDay - now) / 1000;
    let h = parseInt(dis / (60 * 60));
    let m = parseInt((dis / 60) % 60);
    let s = parseInt(dis % 60);
    return `${formatTime(h)}${split}${formatTime(m)}${split}${formatTime(s)}`;
};
/**
 * 返回两个日期之间的差异 (以天为值)。
 * @param {Date} dateInitial
 * @param {Date} dateFinal
 * @ueage getDaysDiffBetweenDates(new Date("2017-12-13"), new Date("2017-12-22")) -> 9
 */

const getDaysDiffBetweenDates = (dateInitial, dateFinal) =>
    (dateFinal - dateInitial) / (1000 * 3600 * 24);

const formatTime = (s) => {
    return Number(s) >= 10 ? s : '0' + s;
};

/**
 *
 * @param {Array} rest [2019, 4, 14, 0, 0, 0, 0] 5月
 */
const isOffLine = (rest) => {
    return new Date(...rest).getTime() < Date.now();
};
/**
 * 获取某个cookie
 * @param {string} name cookie的key
 * @return {string} cookie的value
 */
const getCookie = (name) => {
    let arr;
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) {
        return unescape(arr[2]).replace(/\"/g, ''); //替换引号
    } else {
        return null;
    }
};

/**
 * 删除cookie
 * @param name cookie的名称
 */
// const delCookie = name => {
//     setCookie(name, " ", -1);
// };

/**
 * 判断页面登录
 * @Author   wangmeng
 * @DateTime 2019-01-08
 */
const getPPU = (_) => {
    return !!getCookie('PPU');
};

/**
 * M端登录
 * @Author   wangmeng
 * @DateTime 2019-01-08
 * @param {Object} options 58同城M端登录配置项目
 * @param {boolean} options.isPopup 弹窗登录(手机验证码)还是passport登录页面弹窗登录则是有path配置项可用 默认false
 * @param {string} options.path 登录成功后回调 不传则默认当前页面url
 * @param {string} options.source 来源 只适用于弹窗登录
 * @param {number} options.defaulttype 1默认展示账号登录 2手机动态码
 * @param {number} options.onlymobile 1 限制只能用手机号动态码登录
 * @param {number} options.onlypwd 1 限制只能账号密码
 * @param {number} options.ishidethird 1 隐藏第三方登录
 * @param {number} options.ishidetpage 1隐藏右上角登录按钮
 */
const login_M = ({
    isPopup = false,
    path = '',
    source = '',
    defaulttype = 1,
    onlymobile = false,
    onlypwd = false,
    ishidethird = false,
    ishidetpage = false,
    bgImage,
    btnImage,
    callback
} = {}) => {
    function _parse(key, val) {
        return val ? `&${key}=${encodeURIComponent(val)}` : '';
    }
    let back_path = path || window.location.href;
    let params =
        _parse('defaulttype', defaulttype) +
        _parse('onlymobile', onlymobile) +
        _parse('onlypwd', onlypwd) +
        _parse('ishidethird', ishidethird) +
        _parse('ishidetpage', ishidetpage);
    if (!isPopup) {
        window.location.href = `//m.m.58.com/login/?path=${encodeURIComponent(
            back_path
        )}${params}`;
    } else {
        // 可优化
        let callParams = {
            path: back_path,
            source,
            callback
        }
        if (bgImage) {
            callParams.bgImage = bgImage
        }
        if (btnImage) {
            callParams.btnImage = btnImage
        }
        if (!window.loginInSDK) {
            loadJS(
                '//j1.58cdn.com.cn/js/login/passportMobileLogin.js',
                function () {
                    loadJS(
                        '//j1.58cdn.com.cn/git/base-service/loginSDK/build/bundle.js',
                        function () {
                            window.loginInSDK(callParams);
                        }
                    );
                }
            );
        } else {
            window.loginInSDK(callParams);
        }
    }
};

/**
 * 点击复制到剪切板中 使用execCommand API
 * https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript/30810322#30810322
 * @param {string} text 要复制的内容
 * @return {promise} new promise
 */

const fallbackCopyTextToClipboard = (text) => {
    let textArea = document.createElement('textarea');
    let root = document.getElementById('root');
    textArea.value = text;
    // document.body.appendChild(textArea);
    document.body.insertBefore(textArea, root);
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange(0, text.length); //不设置的话ios 会有问题
    return new Promise((reslove, reject) => {
        try {
            let success = document.execCommand('copy');
            reslove(success);
        } catch (err) {
            reject(err);
        }
        document.body.removeChild(textArea);
    });
};

/**
 * 点击复制到剪切板中 使用 navigator.clipboard.writeText(text)
 * @param {string} text 要复制的内容
 * @return {promise} new promise
 */

const copyTextToClipboard = (text) => {
    if (!navigator.clipboard) {
        return fallbackCopyTextToClipboard(text);
    }
    return new Promise((reslove, reject) => {
        navigator.clipboard.writeText(text).then(
            function () {
                reslove('success');
            },
            function (err) {
                reject(err);
            }
        );
    });
};

const copyTextToClipboard2 = (str) => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    const selected =
        document.getSelection().rangeCount > 0
            ? document.getSelection().getRangeAt(0)
            : false;
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
    }
};
/**
 * 函数防抖
 * @param  {function} func 需要防抖的函数
 * @param  {string} wait 时间
 * @return {function} 防抖函数
 */
const simpleDebounce = (func, wait) => {
    let timer;
    return (_) => {
        timer && clearTimeout(timer);
        timer = setTimeout(func, wait);
    };
};
/**
 * 函数防抖
 * @param  {function} func 需要防抖的函数
 * @param  {number} wait 时间
 * @param  {bollean} immediate  是否立即执行
 * @return {function} 防抖函数
 */
const debounce = (func, wait=300, immediate) => {
    var timeout, result;

    return function () {
        var context = this;
        var args = arguments;

        if (timeout) clearTimeout(timeout);
        if (immediate) {
            // 如果已经执行过，不再执行
            var callNow = !timeout;
            timeout = setTimeout(function () {
                timeout = null;
            }, wait);
            if (callNow) result = func.apply(context, args);
        } else {
            timeout = setTimeout(function () {
                result = func.apply(context, args);
            }, wait);
        }

        return result;
    };
};

/**
 * 函数节流
 * @param  {function} func 需要节流的函数
 * @param  {strimg} wait
 * @return {function} 节流的函数
 * 其实时间戳版和定时器版的节流函数的区别就是，时间戳版的函数触发是在时间段内开始的时候，而定时器版的函数触发是在时间段内结束的时候。
 */
const throttle = (func, wait) => {
    let canRun = true;
    return function (...args) {
        if (!canRun) return;
        canRun = false;
        const context = this;
        setTimeout(() => {
            canRun = true;
            func.apply(context, args);
        }, wait);
    };
};

let previous = 0;

function throttle2(func, wait) {
    return function () {
        let now = Date.now();
        let context = this;
        let args = arguments;
        console.log(now - previous);
        if (now - previous > wait) {
            func.apply(context, args);
            previous = now;
        }
    };
}

/**
 * 解析url参数
 * @example ?id=12345&a=b
 * @return {object} {id:12345, a:b}
 * */
const urlParse = () => {
    let url = window.location.search;
    let obj = {};
    let reg = /[?&][^?&]+=[^?&]+/g;
    let arr = url.match(reg);
    if (arr) {
        arr.forEach((item) => {
            let tempArr = item.substr(1).split('=');
            let key = decodeURIComponent(tempArr[0]);
            let val = decodeURIComponent(tempArr[1]);
            obj[key] = val;
        });
    }
    return obj;
};

/**
 * 解析url参数
 * @example http://test.58.com:8084/#/?id=15&a=2
 * @return {any} {id:15, a:2}
 * */
const getURLParameters = (url = window.location.href) =>
    (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
        (a, v) => (
            (a[v.slice(0, v.indexOf('='))] = decodeURIComponent(
                v.slice(v.indexOf('=') + 1)
            )),
            a
        ),
        {}
    );

/**
 * 解析url参数
 * @example http://test.58.com:8084/#/?id=15&a=2
 * @return {any} {id:15, a:2}
 * */
const getHashParams = ()=> {
    let hash = window.location.hash;
    let query = hash.substring(hash.indexOf('?') + 1)
    let obj = {}
    let arr = query.split('&')
    for (let i = 0; i < arr.length; i++) {
        let newarr = arr[i].split('=')
        obj[newarr[0]] = newarr[1] ? decodeURIComponent(newarr[1]) : ''
    }
    return obj
}
/**
 * 根据对象某属性排序
 * @Author   wangmeng
 * @DateTime 2019-01-03
 * @param    {String} prop 对象属性
 * @param    {Boolean}  boolean 排序规则
 *
 */

const sortBy = (prop, boolean = true) => {
    let flag = boolean ? 1 : -1;
    return function (a, b) {
        return a[prop] < b[prop] ? flag * -1 : flag;
    };
};

/**
 * 缓存函数计算的结果 仅支持一个参数传递
 * @Author   wangmeng
 * @DateTime 2019-02-11
 * @param    {Function} fn 要缓存的函数
 * @return   {Function}      缓存后的函数
 * @useage const cachedComputed = cached(funcA); cachedComputed(1)
 */

const cached = (fn) => {
    const cache = Object.create(null);
    return function cachedFn(str) {
        if (!cache[str]) {
            cache[str] = fn(str);
        }
        return cache[str];
    };
};

/**
 * 兼容浏览器animationend时间
 */
const transitionEvent = ~(function () {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
        transition: 'transitionend',
        OTransition: 'oTransitionEnd',
        MozTransition: 'transitionend',
        WebkitTransition: 'webkitTransitionEnd',
    };

    for (t in transitions) {
        if (el.style[t] !== undefined) {
            return transitions[t];
        }
    }
})();

const preloadImage = (url, callback) => {
    var img = new Image(); //创建一个Image对象，实现图片的预下载
    img.src = url;

    if (img.complete) {
        // 如果图片已经存在于浏览器缓存，直接调用回调函数
        callback && callback.call(img);
        return; // 直接返回，不用再处理onload事件
    }

    img.onload = function () {
        //图片下载完毕时异步调用callback函数。
        callback && callback.call(img); //将回调函数的this替换为Image对象
    };
};
/**
 * 预加载图片资源
 *
 * @export
 * @param {*} srcArr
 */
const preloadImageArr = (srcArr, onloaded) => {
    let loadList = [];
    if (srcArr instanceof Array) {
        for (var i = 0; i < srcArr.length; i++) {
            let oImg = new Image();
            oImg.src = srcArr[i];
            if (onloaded) {
                let promiseLoad = new Promise((resolve) => {
                    oImg.onload = () => {
                        oImg.onload = null;
                        resolve(true);
                    };
                });
                loadList.push(promiseLoad);
            }
        }
        if (onloaded) {
            Promise.all(loadList).then((result) => {
                let falseList = result.filter((elem) => {
                    return !elem;
                });
                if (falseList.length <= 0) {
                    onloaded();
                    return;
                }
                console.log(result);
            });
        }
    } else if (typeof srcArr === 'string' && srcArr !== '') {
        let oImg = new Image();
        oImg.src = srcArr;
        if (onloaded) {
            oImg.onload = () => {
                oImg.onload = null;
                onloaded();
            };
        }
    }
};
/**
 * 退出挽留
 */
const quitHandler = (backHandler) => {
    // console.log("quitHandler", backHandler);
    //新开webview只有1条浏览器记录，不会触发popstate，需要增加一条浏览器记录；
    window.history.pushState({}, null, window.location.href);
    //侦听返回事件，并跳转到特定页面(spa中都有路由处理，无需关心)
    // bugfix:小米和vivo手机上，存在页面加载自动触发popstate事件的问题
    backHandler &&
        window.setTimeout(function () {
            // window.onpopstate = backHandler;
            window.addEventListener('popstate', backHandler);
        }, 500);
};

/**
 * 粘合参数
 * @example
 * concatParams({a:1,b:2},'http://www.58.com?c=4')
 *
 */
const concatParams = (obj, url) => {
    let params = url ? getURLParameters(url) : getURLParameters();
    if(params.os && params.os.indexOf('android') > -1){
        delete params.os
    }
    console.log('params:::', params)
    Object.assign(params, obj);
    return qs.stringify(params);
};

/* m/pc页面展现埋点*/
const reTrackLog = (pagetype, page, cate, area) => {
    if (!isInAPP) {
        window._trackURL = JSON.stringify({
            pagetype,
            page,
            cate,
            area,
        });
        if (window.reTrackLog) {
            window.reTrackLog();
        } else {
            setTimeout(() => {
                window.reTrackLog && window.reTrackLog();
            }, 300);
        }
    }
};

/**
 * 判断是否支持webp
 * @return {boolean}
 */
const checkWebp = () => {
    try {
        return (
            document
                .createElement('canvas')
                .toDataURL('image/webp')
                .indexOf('data:image/webp') === 0
        );
    } catch (err) {
        return false;
    }
};

/**
 * 洗牌
 * @param {array} array
 * @return {array} 洗牌后的array
 */
function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

function fetchFile(url) {
    return new Promise((reslove, reject) => {
        let xhr;
        if (window.ActiveXObject) {
            // eslint-disable-next-line no-undef
            xhr = new ActiveXObject('Microsoft.XMLHTTP');
        } else if (window.XMLHttpRequest) {
            xhr = new XMLHttpRequest();
        }
        if (xhr) {
            // todo 跨域支持
            // c.58cdn.com.cn不支持跨域-> img.58.com.cn
            xhr.open('GET', url);
            xhr.send();
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        let text = xhr.responseText;
                        reslove(text);
                    } else {
                        reject(xhr);
                    }
                }
            };
        }
    });
}

function loadJS(url, callback) {
    let script = document.createElement('script');
    if (script.readyState) {
        // IE
        script.onreadystatechange = function () {
            if (
                script.readyState === 'loaded' ||
                script.readyState === 'complete'
            ) {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {
        // 其他浏览器
        script.onload = function () {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}


function calcTime() {
    let now = new Date()
    let day = now.getDay()
    let d = 0;
    if (day === 5) {
        d = 5 + (7 - day) -1
        // return false
    } else if (day < 5) {
        d = 5 - day - 1
    } else {
        d = 5 + (7 - day) -1
    }
    let str = timeToNextDay()
    return `${d}天${str}`
}

/**
 * 
 * 距离下个周几的具体日期
 */
function timeToWeek(targetDay) {
    let now = new Date()
    let day = now.getDay()
    let d = 0;
    if (day === targetDay) {
        return '今日'
    } else if (day < 5) {
        d = 5 - day 
    } else {
        d = 5 + (7 - day) 
    }
    let target = new Date(now.getTime() + d * 24*60*60*1000)
    return `${target.getMonth()+1}月${target.getDate()}日`
}

function copyMap(map) {
    let result = new Map()
    for(let [key,value] of map.entries()) {
        result.set(key,JSON.parse(JSON.stringify(value)))
    }
    return result
}

/**  
 * 动态创建webworker线程
 */

 const makeWorker = func => {
     let pendingJobs = {};
     const worker = new Worker (
        URL.createObjectURL (new Blob ([`(${func.toString ()})()`]))
      )
      worker.onmessage = ({data: {result, jobId}}) => {
        pendingJobs[jobId](result);
        delete pendingJobs[jobId];
      };
    
    
      return (...params) => {
          return new Promise(reslove => {
              const jobId = Math.random();
              pendingJobs[jobId] = reslove;
              worker.postMessage({jobId,params})
          })
      }
 }

//  function work () {
//     onmessage = ({data: {jobId, message}}) => {
//       console.log ('i am worker, receive:-----' + message);
//       postMessage ({jobId, result: 'message from worker'});
//     };
//   }
//  const testWorker = makeWorker (work);

//  testWorker ('message from main thread').then (message => {
//    console.log ('i am main thread, i receive:-----' + message);
//  });

const transformTime = function(date,showMonth=false) {
    let t = new Date(date)
    return showMonth ? `${t.getMonth()+1}月${t.getDate()}日 ${t.getHours()}:${t.getMinutes() < 10 ? '0'  + t.getMinutes() : t.getMinutes()}`
    : `${t.getHours()}:${t.getMinutes() < 10 ? '0'  + t.getMinutes() : t.getMinutes()}`
}

const compareTime = function (){
    const myDate = new Date().getTime();
    const startTime = new Date('2022-2-7 00:00:00'.replace(/-/g, '/')).getTime();
    const endTime = new Date('2022-3-7 23:00:00'.replace(/-/g, '/')).getTime()
    if(myDate >= startTime && myDate <= endTime) {
        return true;
    }
    return false;

}

export {
    scrollToTop,
    smoothScroll,
    validateEmail,
    validateNumber,
    validataPhone,
    validataFixedLineTelephone,
    validateNumberAndLetter,
    validataOS,
    getScrollTop,
    getClientHeight,
    getScrollHeight,
    timeToNextDay,
    getCookie,
    getPPU,
    login_M,
    copyTextToClipboard,
    copyTextToClipboard2,
    simpleDebounce,
    debounce,
    throttle,
    throttle2,
    urlParse,
    getURLParameters,
    sortBy,
    animateScroll,
    cached,
    preloadImage,
    preloadImageArr,
    isOffLine,
    getDaysDiffBetweenDates,
    quitHandler,
    transitionEvent,
    concatParams,
    elementIsVisibleInViewport,
    reTrackLog,
    checkWebp,
    shuffleArray,
    fetchFile,
    loadJS,
    calcTime,
    timeToWeek,
    copyMap,
    transformTime,
    compareTime,
    getHashParams
};
